export const bookingNoteTypeToTitle = {
  DIETARY: 'Visit dietary notes',
  GENERAL: 'Visit notes',
  GUEST_PROVIDED: 'Guest-provided order notes',
};

enum BookingNoteTypes {
  GENERAL = 'GENERAL',
  DIETARY = 'DIETARY',
  GUEST_PROVIDED = 'GUEST_PROVIDED',
}

export default BookingNoteTypes;
